"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EksempelKomponent = function EksempelKomponent(_ref) {
  var red = _ref.red;
  return _react.default.createElement("code", {
    style: red ? {
      color: 'red'
    } : {}
  }, "Dette er bare ment som eksempel.");
};

EksempelKomponent.propTypes = {
  red: _propTypes.default.bool
};
EksempelKomponent.defaultProps = {
  red: false
};
var _default = EksempelKomponent;
exports.default = _default;